module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-to-home",
    class: {
      ios: _vm.isSafari
    }
  }, [(_vm.isSafari) ? _c('div', {
    staticClass: "add-to-home-container-ios"
  }, [_c('div', {
    staticClass: "add-to-home-header"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Install the app")]), _vm._v(" "), _c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        return _vm.showHomeScreen(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "user-card"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": _vm.salesIcon,
      "alt": _vm.salesName + 'icon'
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.salesName))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.salesWebsite
    }
  }, [_vm._v(_vm._s(_vm.salesWebsite))])]), _vm._v(" "), _c('ol', {
    staticClass: "instruction"
  }, [_c('li', [_vm._v("\n        Tap on the\n        "), _c('svg', {
    staticClass: "icon",
    attrs: {
      "viewBox": "0 0 32 33",
      "fill": "none"
    }
  }, [_c('rect', {
    attrs: {
      "width": "32",
      "height": "33",
      "rx": "4",
      "fill": "#F2F2F2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "7",
      "y": "11.4492",
      "width": "18",
      "height": "17",
      "rx": "3",
      "stroke": "#0C86FF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "13",
      "y": "10",
      "width": "6",
      "height": "3",
      "fill": "#F2F2F2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.5303 2.46967C16.2374 2.17678 15.7626 2.17678 15.4697 2.46967L10.6967 7.24264C10.4038 7.53553 10.4038 8.01041 10.6967 8.3033C10.9896 8.59619 11.4645 8.59619 11.7574 8.3033L16 4.06066L20.2426 8.3033C20.5355 8.59619 21.0104 8.59619 21.3033 8.3033C21.5962 8.01041 21.5962 7.53553 21.3033 7.24264L16.5303 2.46967ZM16.75 19L16.75 3H15.25L15.25 19H16.75Z",
      "fill": "#0C86FF"
    }
  })]), _vm._v("\n        in the browser toolbar\n      ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', [_vm._v("\n        Look for the\n        "), _c('img', {
    staticClass: "icon",
    attrs: {
      "src": _vm.salesIcon,
      "alt": _vm.salesName + 'icon'
    }
  }), _vm._v(" icon\n        on your home screen\n      ")])])]) : _c('div', {
    staticClass: "add-to-home-container flex"
  }, [(_vm.isChrome && !_vm.isSamsungBrowser) ? _c('div', {
    staticClass: "speech-bubble-container"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.isSamsungBrowser) ? _c('div', {
    staticClass: "speech-bubble-container"
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "flex flex-center"
  }, [_c('div', {
    staticClass: "main-title",
    style: ({
      'border-bottom-color': _vm.customization.mainColor
    })
  }, [_vm._v("\n          DIGITAL CARD BENEFITS\n        ")])]), _vm._v(" "), (_vm.getBenefits.length > 0) ? _c('div', {
    staticClass: "features"
  }, _vm._l((_vm.getBenefits), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "flex feature"
    }, [_c('div', {
      staticClass: "feature-icon",
      style: ({
        background: _vm.customization.mainColor
      })
    }, [_c('div', {
      staticClass: "icon-add-to-home flex flex-center",
      class: item.icon,
      style: ({
        color: _vm.customization.iconColor
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "feature-description flex"
    }, [_vm._v("\n            " + _vm._s(item.text) + "\n          ")])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "select-right",
    staticStyle: {
      "padding-bottom": "10px"
    }
  }, [_c('input', {
    staticClass: "button form_submit",
    staticStyle: {
      "font-size": "13.3px",
      "font-weight": "bold",
      "width": "50%",
      "margin": "0 auto"
    },
    attrs: {
      "type": "button",
      "value": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.showHomeScreen(false)
      }
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v("\n        Scroll down and select\n        "), _c('span', {
    staticClass: "add-home"
  }, [_vm._v("Add to Home Screen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "speech-bubble"
  }, [_c('div', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("SAVE MY CARD")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("\n          Tap"), _c('img', {
    attrs: {
      "src": "/static/images/show-more-button-with-three-dots.svg"
    }
  }), _vm._v("\n          choose "), _c('strong', [_vm._v("Add to Homescreen")]), _vm._v(" and then\n          "), _c('strong', [_vm._v("Save")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "speech-bubble-without-triangle"
  }, [_c('div', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("SAVE MY CARD")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("\n          Tap "), _c('img', {
    attrs: {
      "src": "/static/images/add-homescreen-samsung.svg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Homescreen")]), _vm._v(" and "), _c('strong', [_vm._v("Add")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7e8c1657", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e8c1657"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/add-to-homescreen-adaptive.vue
// module id = 854
// module chunks = 0